import React, { useState, useEffect } from 'react';

const TypingText = () => {
  const [index, setIndex] = useState(0);
  const texts = [
    'F',
    'Fr',
    'Fro',
    'Fron',
    'Front',
    'Front',
    'Fronte',
    'Fronten',
    'Frontend',
    'Frontend ',
    'Frontend W',
    'Frontend We',
    'Frontend Web',
    'Frontend Web ',
    'Frontend Web D',
    'Frontend Web De',
    'Frontend Web Dev',
    'Frontend Web Deve',
    'Frontend Web Devel',
    'Frontend Web Develo',
    'Frontend Web Develop',
    'Frontend Web Develope',
    'Frontend Web Developer',
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((index) => (index + 1) % texts.length);
    }, 300);
    return () => clearInterval(interval);
  }, [texts.length]);

  return (
    <h1 className="text-xl font-medium font-mukta text-gray-600">
      {texts[index]}
      <span className="text-primary">|</span>
    </h1>
  );
};

export default TypingText;

